module.exports = __webpack_public_path__ + "img/paso_5.c5d47f09.png";